import React, { Component } from "react";
import shortid from "shortid";
import SVG from "react-inlinesvg";
import { css } from "react-emotion";

class SvgIcon extends Component {
  svgRef = React.createRef();

  onLoad = () => {
    const { shouldExclude = true } = this.props;
    const node = this.svgRef.current.getElementsByTagName("svg")[0];

    let svg = node.innerHTML ? node.innerHTML.replace(/\n/g, " ") : node.textContent.replace(/\n/g, " ");

    const idsMatch = svg.match(/id="([a-zA-Z0-9]+)"/g);
    const styleTag = svg.match(/<style.+<\/style>/) && svg.match(/<style.+<\/style>/)[0];
    const excludeColors = shouldExclude ? ["#FFFFFF", "#FFF", "#FAFAFA"] : [];

    if (idsMatch) {
      const ids = idsMatch.map(c => c.replace('id="', "").replace('"', ""));
      const idsNew = ids.map(c => shortid.generate());

      svg = svg
        .replace(/id="([a-zA-Z0-9]+)"/g, (m, id) => `id="${idsNew[ids.indexOf(id)]}"`)
        .replace(/url\(#([a-zA-Z0-9]+)\)/g, (m, id) => `url(#${idsNew[ids.indexOf(id)]})`)
        .replace(/xlink:href="#([a-zA-Z0-9]+)"/g, (m, id) => `xlink:href="#${idsNew[ids.indexOf(id)]}"`);
    }

    if (styleTag) {
      const classes = styleTag.match(/\.[a-z0-9]+[{,]/g).map(c => c.replace(/[.{,]/g, ""));
      const classesNew = classes.map(() => shortid.generate());

      svg = svg.replace(
        /class="([a-z0-9 ]+)"/g,
        (m, classNames) =>
          `class="${classNames
            .split(" ")
            .map(className => classesNew[classes.indexOf(className)])
            .join(" ")}"`
      );

      const styleTagNew = styleTag.replace(
        /\.([a-z0-9]+)([{,]+)/g,
        (m, className, x) => `.${classesNew[classes.indexOf(className)]}${x}`
      );

      svg = svg.replace(/<style.+<\/style>/, styleTagNew);
    }

    if (shouldExclude && this.props.currentColor !== false) {
      svg = svg.replace(/#[a-zA-Z0-9]+/g, m => (excludeColors.indexOf(m.toUpperCase()) > -1 ? m : "currentColor"));
    }

    node.innerHTML = svg;
  };

  render() {
    const svg = this.props.src;
    const { className, onClick } = this.props;

    const styles = {
      root: css`
        display: inline-block;
        width: 100%;
        height: 100%;
      `,
    };
    return (
      <span ref={this.svgRef} className={`${styles.root} ${className || ""}`} onClick={onClick}>
        <SVG className={`svg ${styles.root} `} onLoad={this.onLoad} src={svg} />
      </span>
    );
  }
}

export default SvgIcon;
